import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TabLabel.module.scss';
import TabLabelIcon from './TabLabelIcon';

type TabLabelProps = {
  invalid: boolean;
  label: string;
  iconInfo?: {
    name: string;
    tooltip?: string;
  };
};

const TabLabel: React.FC<TabLabelProps> = (props) => {
  const { invalid, label, iconInfo } = props;
  const { t } = useTranslation();

  if (iconInfo) {
    iconInfo.tooltip = iconInfo.tooltip ? t(iconInfo?.tooltip) : undefined;
  }

  return (
    <span id={`tab-label-${label}`} className={styles.TabLabel}>
      {invalid && <TabLabelIcon />}
      {iconInfo && <TabLabelIcon customIcon={iconInfo} isProvidedField />}
      {t(`navTab.${label}`)}
    </span>
  );
};

export default TabLabel;
